import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Link } from "react-router-dom";

import * as actions from "../../actions";
import { formatNumber } from '../../libraries/helper';


const DashboardWidget = ({ items, title, loading = false }) => {
  return <div className=" bg-white  rounded-md   shadow border border-neutral-200 p-5">
    <h3 className="font-bold pb-5">{title}</h3>
    {loading ? <div className="flex  justify-center items-center"><div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div> :
      <ul className="flex flex-col space-y-6 text-neutral-600">
        {items.map((item, i) => {
          return (
            <li key={i} >
              {item.link ? <Link className="flex justify-between items-center" to={item.link}>
                <span>{item.title}</span>
                <span className="font-bold">{formatNumber(item.count)}</span>
              </Link> : <div className="flex justify-between items-center">
                <span>{item.title}</span>
                <span className="font-bold">{formatNumber(item.count)}</span>
              </div>}
            </li>
          );
        })}
      </ul>}
  </div>
}

export default () => {

  const dispatch = useDispatch();
  
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);

  const [user, setUser] = useState({});

  const [productPricesReport, setProductPricesReport] = useState([]);

  const [productPricesReportLoading, setProductPricesReportLoading] = useState(false)

  const [productsReport, setProductsReport] = useState([]);
  
  const [productReportLoading, setProductReportLoading] = useState(false)
  
  const [invoicesReport, setInvoicesReport] = useState([]);

  const [invoicesStatuses, setInvoicesStatuses] = useState([]);
  const [invoicesStatusesLoading, setInvoicesStatusesLoading] = useState(false)
  
  const [invoicesReportCount, setInvoicesReportCount] = useState([]);


  useEffect(() => {
    dispatch(actions.list("users/role"));
  }, []);

  useEffect(() => {

    if (appReducer.auth_currents_list != undefined) {
      setUser(appReducer.auth_currents_list.data);
    }
    if (appReducer.product_prices_report_list != undefined) {
      setProductPricesReport(appReducer.product_prices_report_list.data);
      setProductPricesReportLoading(false)
    }
    if (appReducer.products_report_list != undefined) {
      setProductsReport(appReducer.products_report_list.data);
      setProductReportLoading(false)
    }
    if (appReducer.invoices_report_list != undefined) {
      setInvoicesReport(appReducer.invoices_report_list.data);
    }
    if (appReducer.invoices_statuses_list != undefined) {
      setInvoicesStatusesLoading(false)
      setInvoicesStatuses(appReducer.invoices_statuses_list.data);
    }
    if (appReducer.invoices_report_count_list != undefined) {
      setInvoicesReportCount(appReducer.invoices_report_count_list.data);
    }

  }, [appReducer]);

  useEffect(() => {


    setProductPricesReportLoading(true)
    dispatch(actions.list("product_prices/report"));


    setProductReportLoading(true)
    dispatch(actions.list("products/report"));

    dispatch(actions.list("invoices/report"));
    
    dispatch(actions.list("invoices/report_count"));
    
    setInvoicesStatusesLoading(true)
    
    dispatch(actions.list("invoices/statuses"));
    
    dispatch(actions.list("auth/currents"));

  }, []);

  return (
    <Fragment>

      <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-5">

        {user &&
          <div className=" bg-white border border-neutral-200 shadow space-y-4 rounded-md p-5 flex justify-center flex-col items-center">
          <svg className=" flex-shrink-0 size-16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="9" r="3" stroke="#000" stroke-width="1.5"></circle> <path d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20" stroke="#000" stroke-width="1.5" stroke-linecap="round"></path> <path d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7" stroke="#000" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>
            <h6 className=" text-neutral-500 font-bold">{user.first_name} {user.last_name} </h6>
            <Link className=" bg-black rounded-md p-2 px-4 text-white hover:opacity-70 " to="/profile">پروفایل کاربری</Link>
          </div>
        }

        <DashboardWidget loading={productPricesReportLoading} title="مدیریت موجودی انبار" items={productPricesReport} />

        <DashboardWidget loading={productReportLoading} title="مدیریت محصولات" items={productsReport} />

        <DashboardWidget loading={invoicesStatusesLoading} title="وضعیت سفارشات" items={invoicesStatuses} />

      </div>


      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 my-5">

        <DashboardWidget title="وضعیت فروش (ناخالص)" items={invoicesReport} />

        <DashboardWidget title="تعداد فروش (ناخالص)" items={invoicesReportCount} />

      </div>

    </Fragment>
  );
};
